import React, { useEffect, useState, useRef } from 'react';
import IconButton from '@mui/material/IconButton';
import StarIcon from '@mui/icons-material/Star';
import { useMutation } from '@apollo/client';
import {
  ADD_FAVOURITE_MUTATION,
  REMOVE_FAVOURITE_MUTATION,
} from '../../graph/UserGraph';


export default function Favourite(props) {
  // const dispatch = useDispatch();
  const {
    cardData,
    favouritesData,
  } = props

  const [favouriteID, setFavouriteID] = useState(null)

  const [addFavourite, addFavouriteResult] = useMutation(ADD_FAVOURITE_MUTATION);
  const [removeFavourite, removeFavouriteResult] = useMutation(REMOVE_FAVOURITE_MUTATION);
  let userID = localStorage.getItem("userID")

  const ffirst = useRef(false)
  let favourites = favouritesData

  function CheckFavourite(data) {
    // console.log("this is check favourite", data)
    // console.log("this is card xxxxxxx favourites data", favourites)
    return favourites.some(function (el) {
      //If card data ID matches any element in favourites array, sets favouriteID using useState 
      if (el.report.id === data.id) setFavouriteID(el.id)
      // console.log("this is card favourites check", el.report.id, el.id, data.id)
      return el.report.id === data.id;
    });
  }

  useEffect(() => {
    if (favourites != undefined) {
      CheckFavourite(cardData);
      ffirst.current = true
    }

  }, [])

  useEffect(() => {
    if (ffirst.current === false) return null
    if (favourites != undefined) {
      CheckFavourite(cardData);
    }

  }, [favouriteID])


  function toggleFavourite(report) {
    // console.log("this is inside favourite icon click", report)
    // let favourite = CheckFavourite(report)
    if (favouriteID === null) {
      addFavourite({
        variables: { userID: userID, reportID: cardData.id },
        onCompleted: ((returnedData) => {
          console.log(returnedData.addFavourite.id)
          // set(data)
          setFavouriteID(returnedData.addFavourite.id)
        })
      })
    }
    if (favouriteID !== null) {
      removeFavourite({
        variables: { favouriteID: favouriteID },
        onCompleted: (() => {
          // console.log(returnedData.addFavourite.id)
          // set(data)
          setFavouriteID(null)
        })
      })
    };
  }


  return (

    <IconButton onClick={(() => toggleFavourite(cardData.id))}>
      {favouriteID ? (
        <StarIcon style={{ color: 'red' }} size={20} />
      ) : (
        <StarIcon style={{ color: 'grey' }} size={20} />
      )}
    </IconButton>

  );
}

